import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadItemsStatus: 'idle',
    loadItemsError: undefined as any,
    loadItemsLastArgs: undefined as any,
    loadItemStatus: 'idle',
    loadItemError: undefined as any,
    saveItemStatus: 'idle',
    saveItemError: undefined as any,
    deleteItemStatus: 'idle',
    deleteItemError: undefined as any,

    esolldscList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadItems = createAsyncThunk('esolldscSlice/loadItems', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().esolldscSlice.loadItemsLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/esolldsc/?action=gte&MIN_VERTRAGID=${parentModel.HDR_ID}&MAX_VERTRAGID=${parentModel.HDR_ID}`,
    ))
    promises.push(client.get(
        `/api/ixweb/esoll/`,
    ))

    const [esolldscResRes, esollResRes] = await Promise.all(promises)
    const esolldscRes = getRespData(esolldscResRes, rejectWithValue)
    const esollRes = getRespData(esollResRes, rejectWithValue)

    return {
        data: esolldscRes.map((x: any) => ({
            ...x,
            esoll: { ...esollRes.find((y: any) => y.ESOLLDSCID === x.HDR_ID) },
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadItemsStatus } = getState().esolldscSlice
        return loadItemsStatus !== 'pending'
    }
})

export const loadItem = createAsyncThunk('esolldscSlice/loadItem', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/esolldsc/?action=eql&HDR_ID=${id}`,
    ))
    promises.push(client.get(
        `/api/ixweb/esoll/?action=gte&MIN_ESOLLDSCID=${id}&MAX_ESOLLDSCID=${id}`,
    ))

    const [esolldscResRes, esollResRes] = await Promise.all(promises)
    const esolldscRes = getRespData(esolldscResRes, rejectWithValue, true)
    const esollRes = getRespData(esollResRes, rejectWithValue, true)

    return {
        data: {
            ...esolldscRes,
            esoll: { ...esollRes },
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadItemStatus } = getState().esolldscSlice
        return loadItemStatus !== 'pending'
    }
})

export const saveItem = createAsyncThunk('esolldscSlice/saveItem', async ({ esolldsc }: any, { rejectWithValue }: any) => {
    let promises = []
    if (esolldsc?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/esolldsc/${ esolldsc?.HDR_ID }/`,
            prepareData(esolldsc),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/esolldsc/`,
            prepareData(esolldsc),
        ))
    }

    const [esolldscResRes] = await Promise.all(promises)
    const esolldscRes = getRespData(esolldscResRes, rejectWithValue, true)
    promises = []
    if (esolldsc?.esoll?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/esoll/${ esolldsc?.esoll?.HDR_ID }/`,
            prepareData({ ...esolldsc.esoll, ESOLLDSCID: esolldscRes.HDR_ID }),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/esoll/`,
            prepareData({ ...esolldsc.esoll, ESOLLDSCID: esolldscRes.HDR_ID }),
        ))
    }

    const [esollResRes] = await Promise.all(promises)
    const esollRes = getRespData(esollResRes, null, true)

    return {
        data: {
            ...esolldscRes,
            esoll: { ...esollRes },
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveItemStatus } = getState().esolldscSlice
        return saveItemStatus !== 'pending'
    }
})

export const deleteItem = createAsyncThunk('esolldscSlice/deleteItem', async ({ esolldsc }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/esoll/${esolldsc.esoll.HDR_ID}/`,
    ))
    promises.push(client.delete(
        `/api/ixweb/esolldsc/${esolldsc.HDR_ID}/`,
    ))

    const [value1Res, value2Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)
    const value2 = getRespData(value2Res, rejectWithValue)

    return {
        data: esolldsc.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteItemStatus } = getState().esolldscSlice
        return deleteItemStatus !== 'pending'
    }
})

const EsolldscSlice = createSlice({
    name: 'esolldscSlice',
    initialState,
    reducers: {
        resetloadItemsError: (state) => {
            state.loadItemsError = undefined
        },
        resetloadItem: (state) => {
            state.formItem = undefined
            state.loadItemError = undefined
        },
        resetloadItemError: (state) => {
            state.loadItemError = undefined
        },
        resetsaveItem: (state) => {
            state.formItem = undefined
            state.saveItemError = undefined
        },
        resetsaveItemError: (state) => {
            state.saveItemError = undefined
        },
        resetdeleteItemError: (state) => {
            state.deleteItemError = undefined
        },
        removeFromEsolldscListById: (state, action) => {
            state.esolldscList = state.esolldscList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromEsolldscListByIds: (state, action) => {
            state.esolldscList = state.esolldscList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.esolldscList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadItemsStatus = 'preloaded'
            state.loadItemsLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.esolldscList = []
            state.loadItemsStatus = 'idle'
            state.loadItemsLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadItems.pending, (state) => {
            state.loadItemsStatus = 'pending'
            state.loadItemsError = undefined
        })
        builder.addCase(loadItems.fulfilled, (state, action) => {
            state.loadItemsStatus = 'idle'

            if (!action.payload) { return }

            state.loadItemsLastArgs = action.payload.args

            {
                state.esolldscList = action.payload.data

            }
        })
        builder.addCase(loadItems.rejected, (state, action) => {
            state.loadItemsStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadItemsError = action.error.message
            } else {
                state.loadItemsError = action.payload
            }
        })

        builder.addCase(loadItem.pending, (state) => {
            state.loadItemStatus = 'pending'
            state.loadItemError = undefined
        })
        builder.addCase(loadItem.fulfilled, (state, action) => {
            state.loadItemStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.esolldscList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.esolldscList.push(newItem) }
                else { state.esolldscList[i] = { ...state.esolldscList[i], ...newItem } }
            }
        })
        builder.addCase(loadItem.rejected, (state, action) => {
            state.loadItemStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadItemError = action.error.message
            } else {
                state.loadItemError = action.payload
            }
        })

        builder.addCase(saveItem.pending, (state) => {
            state.saveItemStatus = 'pending'
            state.saveItemError = undefined
        })
        builder.addCase(saveItem.fulfilled, (state, action) => {
            state.saveItemStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.esolldscList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.esolldscList.push(newItem) }
                else { state.esolldscList[i] = { ...state.esolldscList[i], ...newItem } }
            }
        })
        builder.addCase(saveItem.rejected, (state, action) => {
            state.saveItemStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveItemError = action.error.message
            } else {
                state.saveItemError = action.payload
            }
        })

        builder.addCase(deleteItem.pending, (state) => {
            state.deleteItemStatus = 'pending'
            state.deleteItemError = undefined
        })
        builder.addCase(deleteItem.fulfilled, (state, action) => {
            state.deleteItemStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.esolldscList = state.esolldscList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.esolldscList = state.esolldscList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteItem.rejected, (state, action) => {
            state.deleteItemStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteItemError = action.error.message
            } else {
                state.deleteItemError = action.payload
            }
        })

    }
})

export const {
    resetloadItemsError,
    resetloadItem,
    resetloadItemError,
    resetsaveItem,
    resetsaveItemError,
    resetdeleteItemError,
    removeFromEsolldscListById,
    removeFromEsolldscListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = EsolldscSlice.actions
export default EsolldscSlice.reducer
